<script>
export default {
  name: 'MenuLinkItem',
  props: {
    href: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true
    },
    linkType: {
      type: String,
      required: true,
      validator: value => {
        return ['nuxtLink', 'routerLink', 'a'].includes(value)
      }
    },
    hasLinkIcon: {
      type: Boolean,
      default: false
    },
    isHeading: {
      type: Boolean,
      default: false
    },
    subHeading: {
      type: String,
      default: ''
    },
    hasHeadingIcon: {
      type: Boolean,
      default: true
    },
    isFooter: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'link',
      validator: value => {
        return ['link', 'dropdown'].includes(value)
      }
    },
    borderedIconDropdown: {
      type: Boolean,
      default: false
    },
    targetBlank: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    linkLocation() {
      let target = '_self'
      let rel = ''
      if (this.targetBlank) {
        target = '_blank'
        rel = 'noreferrer'
      }
      return this.linkType === 'a'
        ? { href: this.href, target, rel }
        : { to: this.href }
    },
    footerClasses() {
      return this.isFooter
        ? 'text--white menu-link-item--footer'
        : 'text--carbon'
    },
    headingClass() {
      return this.isHeading ? 'heading--regular' : ''
    },
    dropdownClass() {
      return this.borderedIconDropdown ? 'menu-link-item__separator' : ''
    }
  }
}
</script>

<template lang="pug">
component.menu-link-item.fw--regular(
  :is='linkType'
  v-bind='linkLocation'
  :class='[footerClasses, headingClass, dropdownClass]'
  v-on='$listeners'
) 
  .menu-link-item__wrapper(
    :class='{ "menu-link-item__wrapper--text-only": !isHeading && !hasLinkIcon }'
  ) 
    .menu-link-item__link-wrapper
      img.menu-link-item__icon(
        alt='thriva-heart'
        v-if='hasLinkIcon'
        src='../../assets/images/icons/thriva-heart.svg'
      ) 
      img.menu-link-item__user-icon(
        alt='user icon'
        v-if='borderedIconDropdown'
        src='../../assets/images/icons/user.svg'
      )
      .menu-link-item__text(
        :class='{ "menu-link-item__arrow": isHeading }'
        @click='$emit("menuLinkClick", { text, link: linkLocation })'
      ) {{ text }}
      img.menu-link-item__chevron(
        v-if='type === "dropdown"'
        alt='chevron'
        src='../../assets/images/icons/chevron-20.svg'
      )
    p.menu-link-item__sub-heading.body--small(v-if='subHeading') {{ subHeading }}
  img.menu-link-item__image(
    v-if='isHeading && hasHeadingIcon'
    alt='thriva-kit'
    src='../../assets/images/illustrations/thriva-kit.svg'
  )
</template>

<style lang="stylus" scoped>
@import '../../assets/styles/modules/*'
.menu-link-item
  display: flex
  flex-direction: column
  padding: 15px 20px

  &:hover
  &:active
  &:focus
    background-color: THRIVA.colours.snow
    color: THRIVA.colours.carbon
    cursor: pointer

  &--footer
    padding: 10px 30px 10px 0

    &:hover
    &:active
    &:focus
      background-color: THRIVA.colours.carbon
      color: THRIVA.colours.lagoon
      cursor: pointer

  +media-breakpoint-up(475px)
    flex-direction: row
    max-width: 420px
    overflow: hidden

  &__text::first-letter
    text-transform: capitalize

  &__wrapper
    display: flex
    flex-direction: column
    justify-content: center
    width: 100%
    +media-breakpoint-up(md)
      min-width: 220px

    &--text-only
      min-width: unset

  &__link-wrapper
    display: flex
    flex-direction: row
    align-items: center

  &__sub-heading
    display: flex
    margin: .6875rem 0 0 0

  &__arrow::after
    content:url('../../assets/images/icons/chevron-16.svg')
    position: relative
    top: 2px

  &__chevron
    transform: rotate(90deg)
    width: 14px
    margin-left: 5px
    margin-top: 2px

  &--active
    border-bottom: 2px solid THRIVA.colours.blue
    &:hover
    &:active
    &:focus
      background-color: transparent
      color: THRIVA.colours.carbon

  &--top-level
    &:hover
    &:active
    &:focus
      background-color: transparent

  &__icon
    max-width: 28px
    margin-right: 16px

  &__image
    display: flex
    flex-direction: column
    margin: 30px 0 0 0
    justify-content: center
    align-self: center
    width: 104px
    +media-breakpoint-up(475px)
      margin: 0 0 0 15px

  &__user-icon
    padding-right: 10px

  &__separator
    border-left: 0.0625rem solid THRIVA.colours.cloud
</style>
